import { configureStore } from '@reduxjs/toolkit'

import activityReducer from './activitySlice'
import authReducer from './authSlice'
import connectivityReducer from './connectivitySlice'
import filterReducer from './filterSlice'
import geolocationReducer from './geolocationSlice'
import listReducer from './listSlice'
import locationReducer from './locationSlice'
import mapReducer from './mapSlice'
import miscReducer from './miscSlice'
import placeReducer from './placeSlice'
import reviewReducer from './reviewSlice'
import saveReducer from './saveSlice'
import settingsReducer from './settingsSlice'
import shareReducer from './shareSlice'
import typeReducer from './typeSlice'
import viewportReducer from './viewportSlice'

export const store = configureStore({
  reducer: {
    map: mapReducer,
    list: listReducer,
    filter: filterReducer,
    settings: settingsReducer,
    auth: authReducer,
    misc: miscReducer,
    location: locationReducer,
    review: reviewReducer,
    share: shareReducer,
    geolocation: geolocationReducer,
    place: placeReducer,
    type: typeReducer,
    viewport: viewportReducer,
    activity: activityReducer,
    connectivity: connectivityReducer,
    save: saveReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
})
